<template>
  <div class="content" ref="contentRef">
    <!--翻页按钮-->
    <div
      class="previous-page page-button"
      :class="{ 'on-show': showPageHan }"
      @mouseover="showPageHan = !showPageHan"
      @click="$emit('onPreviousClick')"
      @mouseout="showPageHan = !showPageHan"
    >
      <div class="in"><LeftOutlined :style="{ color: '#fff' }" /></div>
    </div>
    <div
      class="next-page page-button"
      :class="{ 'on-show': showPageHanNext }"
      @mouseover="showPageHanNext = !showPageHanNext"
      @click="$emit('onNextClick')"
      @mouseout="showPageHanNext = !showPageHanNext"
    >
      <div class="in"><RightOutlined :style="{ color: '#fff' }" /></div>
    </div>
    <!--end 翻页按钮-->
    <div class="group">
      <div class="rotate9"><span>By Event</span></div>
      <div
        class="row"
        v-for="items in overviewDataA"
        :key="items.andonCategoryName"
      >
        <div class="col title" :style="conCol">
          {{ items.andonCategoryName }}
        </div>
        <div
          class="col"
          v-for="item in items.andonCategory"
          :key="item.andonCategoryName"
          :style="conCol"
          @click="$emit('colClick', { ...item, row: items.andonCategoryName })"
          :class="showColor(item)"
        >
          <span class="ic">
            <i class="iconfont" :class="iconType(items, item)"></i>
          </span>
          <span class="txt" v-html="subTotal(items, item)"></span>
        </div>
        <div
          class="col flex-w2"
          :style="conCol"
          @click="$emit('showAndonSummary', items)"
        >
          <column-progress-bar
            :is-number="items.isNumber"
            :number="items.summary * 1"
            :sum-percent="items.sumPercent * 1"
            width="100"
          ></column-progress-bar>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="group">
      <div class="rotate9">
        <span>By Time Limit</span>
      </div>
      <div
        class="row"
        v-for="items in overviewDataB"
        :key="items.andonCategoryName"
      >
        <div class="col title" :style="conCol">
          {{ items.andonCategoryName }}
        </div>
        <div
          class="col"
          v-for="item in items.andonCategory"
          :key="item.id"
          :style="conCol"
          @click="$emit('colClick', { ...item, row: items.andonCategoryName })"
          :class="showColor(item)"
        >
          <span class="ic">
            <i class="iconfont" :class="iconType(items, item)"></i>
          </span>

          <text-scroll
            :wait-time="items.scrollInterval"
            :data="subTotal(items, item)"
            v-if="items.needScroll && subTotal(items, item) !== '-'"
          ></text-scroll>
          <span v-else>{{ subTotal(items, item) }}</span>
        </div>
        <div
          class="col flex-w2"
          :style="conCol"
          @click="$emit('showAndonSummary', items)"
        >
          <column-progress-bar
            :is-number="items.isNumber"
            :number="items.summary * 1"
            :sum-percent="items.sumPercent * 1"
            width="100"
          ></column-progress-bar>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { throttle } from '@/utils'
  import ColumnProgressBar from './column-progress-bar'
  import textScroll from './text-scroll.vue'
  import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
  export default {
    components: {
      ColumnProgressBar,
      textScroll,
      LeftOutlined,
      RightOutlined,
    },
    props: {
      overviewData: {
        type: Array,
        default() {
          return []
        },
      },
    },
    data() {
      return {
        conCol: {},
        showPageHan: false,
        showPageHanNext: false,
      }
    },
    computed: {
      overviewDataA() {
        return this.overviewData.filter((item) => item.andonGrp === 'A')
      },
      overviewDataB() {
        return this.overviewData.filter((item) => item.andonGrp === 'B')
      },
    },
    watch: {
      overviewData: {
        handler() {
          this.init()
        },
        immediate: true,
      },
    },
    mounted() {
      window.addEventListener('resize', throttle(this.init, 500))
    },
    methods: {
      showSummary(item) {
        this.$emit('showSummary', item)
      },
      init() {
        const cHeight = this.$refs.contentRef
          ? this.$refs.contentRef.clientHeight
          : 500
        const rowSize = this.overviewData.length
        const h = Math.max((cHeight - 2) / rowSize, 40)
        this.conCol = { height: h + 'px', lineHeight: h + 'px' }
      },
      showColor(item) {
        if (item.cellColor == 'red' || item.cellColor == 'borderRed') {
          return 'danger'
        } else if (item.cellColor == 'green') {
          return 'green'
        }
        return
      },

      iconType(par, item) {
        var setIcon = function (a, b) {
          if (item.cellColor == 'red') {
            return a
          } else {
            return b
          }
        }
        switch (par.andonIcon) {
          case 'Safety':
            return setIcon('icon-add', 'icon-add-o')

          case 'Quality':
            return setIcon('icon-ling', 'icon-ling-o')

          case 'Material':
            return setIcon('icon-ladder', 'icon-ladder-o')

          case 'Machine':
            return setIcon('icon-tool', 'icon-tool-o')

          case 'Others':
            return setIcon('icon-nabla', 'icon-nabla-o')

          case 'Miss_Takt':
            return setIcon('icon-clock', 'icon-clock-o')

          case 'Miss_Kit':
            return setIcon('icon-k', 'icon-k-o')

          case 'Miss_FIFO':
            return setIcon('icon-f', 'icon-f-o')

          case 'Miss_Sub':
            return setIcon('icon-s', 'icon-s-o')

          case 'Miss_SM':
            return setIcon('icon-e', 'icon-e-o')
        }
      },
      subTotal(items, item) {
        var openArr = [],
          closeArr = [],
          responsedArr = [],
          nameArr = []
        item.andonArray.forEach((v) => {
          if (v.status == 'open') {
            openArr.push(v.status)
          } else if (v.status == 'closed') {
            closeArr.push(v.status)
          } else if (v.status == 'responsed') {
            responsedArr.push(v.status)
          }
          if (v.status != 'closed') {
            nameArr.push(v.name)
          }
        })
        if (items.needSubTotal || items.andonGrp == 'A') {
          if (
            openArr.length > 0 ||
            responsedArr.length > 0 ||
            closeArr.length > 0
          ) {
            return (
              '<i>' +
              (openArr.length + responsedArr.length + closeArr.length) +
              '</i>'
            )
          }
        } else if (!items.needSubTotal && items.andonGrp != 'A') {
          if (items.needScroll && nameArr.length > 1) {
            // var iHtml = ''
            // for (var i = 0; i < nameArr.length; i++) {
            //   iHtml += '<i>' + nameArr[i] + '</i>'
            // }
            // return "<span class='in'>" + iHtml + '</span>'
            return nameArr
          } else if (nameArr.length == 1) {
            return nameArr[0]
          }
          return '-'
        }
        return '-'
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .content {
    box-shadow: 2px 0 2px @black1;
    background-color: #fefefe;
    position: relative;
    height: calc(100vh - 150px - 32px - 10px);
    overflow: hidden;
    .group {
      position: relative;
      padding-left: 50px;
      background-color: #f4f5f7;
      min-height: 200px;
      > .row:last-child > .col {
        border-bottom: none;
      }
    }

    .row {
      padding: 0;
      margin: 0;
      overflow: hidden;
      border-left: 1px solid @black1;
      background: #fefefe;
      display: flex;
      width: 100%;
      .col {
        height: 56.4px;
        line-height: 56.4px;
        border-right: 1px solid #f7f7f8;
        border-bottom: 1px dashed #cdd0d2;
        text-align: center;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:nth-last-child(2) {
          border-color: @lineBlue;
        }
        &:not(.title) {
          cursor: pointer;
          transition: all 0.3s;
          :hover {
            transform: scale(1.01);
          }
        }
        &.flex-w2 {
          flex: 0 0 200px;
          background: #f4f5f7;
          border: none;
          text-align: left;
          padding-left: 20px;
          &.-px {
            box-shadow: 3px 0 3px -1px @black1 inset;
          }
        }
        &.title {
          box-shadow: 2px 0 2px @black1;
          border-right: 1px solid @lineBlue;
          color: #636b80;
          flex: 0 0 100px;
          font-size: 16px;
        }
        &:last-child {
          border-right: none;
        }
        &.danger {
          .ic,
          .txt {
            color: @danger;
          }
        }

        &.green {
          .ic,
          .txt {
            color: @green;
          }
        }
        .ic,
        .txt {
          display: inline-block;
          vertical-align: middle;
          min-width: 40px;
          font-size: 24px;
          color: #d8e0e3;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }
        .txt {
          font-size: 18px;
          min-width: 80px;
        }
        .ic {
          .iconfont {
            font-size: 24px;
          }
        }
      }
    }
  }
  .rotate9 {
    display: block;
    width: 50px;
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    > span {
      display: block;
      width: 100%;
      text-align: center;
      font-weight: normal;
      font-size: 20px;
      color: #636b80;
      writing-mode: vertical-rl;
      height: 100%;
      line-height: 50px;
      transform: rotate(180deg);
    }
  }
  .divider {
    height: 1px;
    background: @lineBlue;
  }
  .previous-page,
  .next-page {
    position: absolute;
    font-size: 40px;
    top: 50%;
    margin-top: -150px;
    left: 0;
    height: 300px;
    min-height: 30px;
    min-width: 30px;
    line-height: 24px;
    width: 50px;
    padding: 0;
    background: transparent;
    z-index: 1000;
  }

  .previous-page .in,
  .next-page .in {
    position: absolute;
    top: 50%;
    margin-top: -24px;
    background: @subMaster;
    border: 1px solid @subMaster;
    width: 48px;
    height: 48px;
    text-align: center;
    border-radius: 50%;
    padding: 0;
    transform: translateX(-70px);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    i.icon {
      vertical-align: middle;
      color: @white;
    }
  }
  .on-show.previous-page,
  .on-show.next-page {
    .in {
      transform: translateX(0);
    }
  }
  .previous-page.activated,
  .next-page.activated {
    border: none;
    background-color: transparent;
  }
  .next-page {
    right: 0;
    left: initial;
    .in {
      transform: translateX(70px);
    }
  }
</style>
